module.exports = __webpack_public_path__ + "static/no-image-28a81226adbe1e8f55b0a1fb050718af.png";